export const generateMazeGrid = (cols, rows) => {
  const directions = [
    [0, -1, 0, 2], [1, 0, 1, 3], [0, 1, 2, 0], [-1, 0, 3, 1]
  ];

  class Cell {
    constructor(x, y) {
      this.x = x;
      this.y = y;
      this.visited = false;
      this.walls = [true, true, true, true]; // top, right, bottom, left
    }
  }

  const grid = Array.from({ length: rows }, (_, y) =>
    Array.from({ length: cols }, (_, x) => new Cell(x, y))
  );

  const stack = [];
  let current = grid[0][0];
  current.visited = true;

  const getNeighbors = (cell) => {
    return directions
      .map(([dx, dy, wallA, wallB]) => {
        const nx = cell.x + dx, ny = cell.y + dy;
        if (nx >= 0 && ny >= 0 && nx < cols && ny < rows) {
          const neighbor = grid[ny][nx];
          if (!neighbor.visited) return { neighbor, wallA, wallB };
        }
        return null;
      })
      .filter(Boolean);
  };

  const removeWalls = (a, b, wallA, wallB) => {
    a.walls[wallA] = false;
    b.walls[wallB] = false;
  };

  while (true) {
    const neighbors = getNeighbors(current);
    if (neighbors.length > 0) {
      const { neighbor, wallA, wallB } = neighbors[Math.floor(Math.random() * neighbors.length)];
      stack.push(current);
      removeWalls(current, neighbor, wallA, wallB);
      neighbor.visited = true;
      current = neighbor;
    } else if (stack.length) {
      current = stack.pop();
    } else {
      break;
    }
  }

  return grid;
};